import LayoutWithSideMenu from '@/layout/layoutWithSideMenu/index.vue'

export const repairManage = {
  path: '/maintenanceModule',
  name: 'maintenanceModule',
  component: LayoutWithSideMenu,
  meta: {
    title: '维保管理'
  },
  children: [
    {
      path: 'repairProcess',
      name: 'repairProcess',
      component: () => import('@/views/maintenanceModule/repairProcess/index.vue')
    },
    {
      path: 'processScheme',
      name: 'processScheme',
      component: () => import('@/views/maintenanceModule/processScheme/index.vue')
    },
    {
      path: 'workmanshipmanage',
      name: 'workmanshipmanage',
      component: () => import('@/views/maintenanceModule/workmanshipmanage/index.vue')
    },
    {
      path: 'repairPlan/mPlan',
      name: 'mPlan',
      component: () => import('@/views/maintenanceModule/mPlan/index.vue')
    },
    {
      path: 'repairPlan/dPlan',
      name: 'dPlan',
      component: () => import('@/views/maintenanceModule/dPlan/index.vue')

    },
    {
      path: 'repairProduction/orderAssignment',
      name: 'orderAssignment',
      component: () => import('@/views/maintenanceModule/orderAssignment/OrderAssignmentList.vue')
    },
    {
      path: 'repairProduction/repairWorkOrder',
      name: 'repairWorkOrder',
      component: () => import('@/views/maintenanceModule/repairWorkOrder/index.vue')
    },
  ]
}
